import {
  CatalogApi,
  CatalogItem,
  CatalogV1ItemListRequest,
  CatalogV1ItemMyListRequest,
  CatalogV1StageListRequest,
  DocumentDownloadRequest,
  InlineResponse20011,
  StageResponse,
} from '@/requests/mainApi';
import { IResponse, requestMachine } from '@/requests/requestMachine';

export default {
  getFlatsInfo(variables: CatalogV1ItemListRequest | undefined): Promise<IResponse<InlineResponse20011>> {
    return requestMachine<InlineResponse20011, CatalogV1ItemListRequest>(
      CatalogApi,
      'catalogV1ItemList',
      true,
      variables
    );
  },
  getMyFlats(variables: CatalogV1ItemMyListRequest | undefined): Promise<IResponse<CatalogItem>> {
    return requestMachine<CatalogItem>(CatalogApi, 'catalogV1ItemMyList', true, variables as never);
  },
  getConstructionStages(variables: CatalogV1StageListRequest): Promise<IResponse<StageResponse>> {
    return requestMachine<StageResponse, CatalogV1StageListRequest>(CatalogApi, 'catalogV1StageList', true, variables);
  },

  downloadObjectDocs(variables: DocumentDownloadRequest): Promise<IResponse<Blob>> {
    return requestMachine<Blob, DocumentDownloadRequest>(CatalogApi, 'downloadObjectDocs', true, variables);
  },
};
